import { faker } from '@faker-js/faker';
import { sample } from 'lodash';

const alert = [...new Array(10)].map(() => ({
  id: faker.datatype.uuid(),
  name: sample(['Inserted Transaction', 'Skimmed Card at ATM', 'Changed Transaction']),
  type: sample(['rule', 'data integrity']),
  acc: sample(['12930214', '21931293', '31232414', '214213122', '21321312']),
  status: sample(['Open', 'Pending Approval', 'Closed-Fraud', 'Closed-Not Fraud']),

  channel: sample(['ATM', 'Mobile Banking']),

  time: sample(['10 hours ago', '11 hours ago', '12 hours ago', '3 hours ago']),
  severity: sample(['High', 'Medium', 'Low']),
}));

export default alert;
